import { getMySchool, isSchoolProfile } from '../../api/v1/schools/schoolActions';
import { getStoredStudentTier, resolveStudentTier } from '../studentTierResolver';

const SCHOOL_DASHBOARD_ROLES = new Set(['school', 'teacher']);

export function shouldUseSchoolDashboard(role) {
  return SCHOOL_DASHBOARD_ROLES.has(role?.toLowerCase());
}

/** After login/verify: `/school` when the user has a linked school (incl. teachers via /teachers/me), `/kids` for kids tier, `/app` otherwise. */
export async function resolveSchoolDashboardPath(token, role, user = null) {
  const normalizedRole = role?.toLowerCase();
  const isAdmin = normalizedRole === 'admin' || normalizedRole === 'superadmin' || user?.is_superuser;
  if (isAdmin) {
    return '/app';
  }

  if (shouldUseSchoolDashboard(normalizedRole) && token) {
    try {
      const school = await getMySchool(token, { role: normalizedRole });
      if (isSchoolProfile(school)) {
        return '/school';
      }
    } catch {
      // Fall through to student/guest check
    }
  }

  const isStudentOrGuest = normalizedRole === 'student' || normalizedRole === 'guest' || user?.is_guest;
  if (isStudentOrGuest) {
    let resolvedTier = null;
    if (user) {
      const studentProfile = user?.role_profile?.student;
      const gradeCode = studentProfile?.grade_code || studentProfile?.grade?.code || user?.grade_code || null;
      const gradeName = studentProfile?.grade_name || null;
      const age = user?.age ?? null;
      const birthDate = user?.birth_date ?? null;
      resolvedTier = resolveStudentTier({ gradeCode, gradeName, age, birthDate });
    }
    if (!resolvedTier) {
      resolvedTier = getStoredStudentTier();
    }
    if (resolvedTier === 'kids') {
      return '/kids';
    }
    if (resolvedTier === 'teen') {
      return '/teen';
    }
    return '/app';
  }

  return '/app';
}
